import React, {useState} from 'react'
import styled from 'styled-components'
import { Icon, InlineIcon } from '@iconify/react';
import timesSolid from '@iconify/icons-la/times-solid';
import { Toggle } from './Toggle'
import { useDispatch } from 'react-redux'

import { toggleActive } from '../../store/data-export/reportSchedulesSlice'
// https://www.robinwieruch.de/react-hooks-fetch-data
// https://dev.to/bdbch/react-hooks-for-data-part-1-fetching-data-28ge

const StyledHeaderBar = styled.div`
  width: 100%;
  height: 40px;
  background: #EEE;
  display: block;
  text-align: center;
  color: #333333;
  line-height: 28px;
  font-size: 18px;
  font-weight: 300;
  position: relative;
`;

const Heading = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translateY(-50%) translateX(-50%);
  transform: translateY(-50%) translateX(-50%);
  display: flex;
`;

const Close = styled.div`
  position: absolute;
  top: 50%;
  right: 0px;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  padding: 10px;
  cursor: pointer;
  line-height: 0;
  color: #FFFFFF;
  background: #233567;
  
  &:hover {
    background: #f6ae38;;
  }
`;

const StyledFontAwesomeIcon = styled(Icon)`
  color: #FFFFFF;
  padding: 0 5px;
`;

const ToggleContainer = styled.div`
  display: block;
  margin: 7px 0 0 20px;
`;

const HeadingText = styled.div`
  display: block;
  margin: 5px 0 0 0px;
`;


export const HeaderBar = ({ scheduled_report}: { scheduled_report: any; }) => {
  
  const dispatch = useDispatch()

  return (
    <StyledHeaderBar>
      <Heading>
      <HeadingText>
        Reports
      </HeadingText>
      <ToggleContainer>
        {typeof scheduled_report !== 'undefined'?
          false && <Toggle selected={scheduled_report.active == 1? true : false} onClick={() => {dispatch(toggleActive(scheduled_report.id))}} />
        : null}
      </ToggleContainer>
      </Heading>
      <Close onClick={() => {window.parent.postMessage({ type: 'CLOSE', payload: {} }, "*"); console.log('CLOSE')}}><Icon width='20px' height='20px' icon={timesSolid} /></Close>
    </StyledHeaderBar>
  )
}